(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.frm-location-info__item');
    if (!trigger) return;

    var groupId = trigger.getAttribute('data-frm-location-group');
    var targetId = trigger.getAttribute('aria-controls');
    if (!groupId || !targetId) return;

    var current = document.getElementById(targetId);
    var wantOpen = !current || !current.hasAttribute('open');

    setTimeout(function () {
      var target = document.getElementById(targetId);
      if (!target) return;

      document.querySelectorAll('.frm-location-info__drawer[data-frm-location-group="' + groupId + '"]').forEach(function (drawer) {
        if (drawer.id !== targetId && drawer.hasAttribute('open')) drawer.hide();
      });

      if (wantOpen && !target.hasAttribute('open')) {
        target.show();
      } else if (!wantOpen && target.hasAttribute('open')) {
        target.hide();
      }
    }, 0);
  }, true);
})();
